const KeenSlider = window.KeenSlider;

const {setInitialised, useArrows, useProgress, useReveal} =
  window.BAO.Carousel.plugins;

class ProductCardCarousel extends window.BAO.CustomElement() {
  connectedCallback() {
    super.connectedCallback();

    if (!this.els?.slide?.exists) return;

    const plugins = [
      setInitialised(),
      useArrows({
        container: this.els?.arrows?.element,
        next: this.els?.next?.element,
        previous: this.els?.previous?.element,
      }),
      useProgress({
        container: this.els?.progress?.element,
        progressbar: this.els?.progressbar?.element,
      }),
    ];

    if (this.dataset.productCardCarouselUseReveal === "true") {
      plugins.push(useReveal(this.els.slide.elements, true));
    }

    this.carousel = this.setupCarousel(plugins);
  }

  setupCarousel(plugins) {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: "snap",
        drag: true,
        rubberband: false,
        defaultAnimation: {
          duration: 50,
        },
        slides: {
          perView: 1,
          spacing: 0,
        },
      },
      plugins,
    );
  }
}

if (!customElements.get("product-card-carousel")) {
  customElements.define("product-card-carousel", ProductCardCarousel);
}
